'use strict';

let isFirstSizeSelection = false;
let selectUiUpdate = false;

/**
 * Update url with if its a first size selection
 * @param {string} selectedUrl - Selected attribute URL
 * @return {string} updated is returned
 */
function getSelectionUrl(selectedUrl) {
    var selectedUrlTemp = selectedUrl;
    if ($('.attributes [data-attr*=color]').length) {
        isFirstSizeSelection = true;
    }
    let url = new URL(selectedUrlTemp);
    if (!isFirstSizeSelection) {
        url.searchParams.append('firstSelection', 'true');
    }
    url.searchParams.append('isPDP', 'true');
    isFirstSizeSelection = true;
    return url.toString();
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 * @param {Object} attr - Attribute
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = '[data-attr*="' + attr.id + '"]';
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url).removeAttr('disabled');
        const $selectEle = $attrValue.closest('select');

        if (attrValue.selected) {
            selectUiUpdate = true;
            $selectEle.val(attrValue.url).change();
            $selectEle.siblings('.invalid-feedback').removeClass('d-block');
            selectUiUpdate = false;
            $productContainer
                .find('.checkbox-' + attr.id + '-' + attrValue.id)
                .removeClass('d-none')
                .siblings()
                .addClass('d-none');
        }

        if (!attrValue.hasvariant) {
            if ($attrValue.is(':selected') && !$('.wishlist-size-selection-form').is(':visible')) {
                selectUiUpdate = true;
                $selectEle.val('').change();
                $selectEle.siblings('.invalid-feedback').addClass('d-block');
                selectUiUpdate = false;
            }
            $attrValue.attr('disabled', true);
        }
    });
}

/**
 * Process the attribute values for an attribute that has image swatches
 * @param {Object} attr - Attribute
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processSwatchValues(attr, $productContainer) {
    $productContainer.find('[data-attr*="' + attr.id + '"] .custom-selected-value').text(attr.displayValue);
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr*="' + attr.id + '"] [data-attr-value="' + attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();
        $attrValue.toggleClass('selected', attrValue.selected);
        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }
        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');
        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 * @param {Object} attrs - Attribute
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAttrs(attrs, $productContainer) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];
    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Updates the product card UI with information retrieved from a product API endpoint.
 * @param {string} urlParam - The URL to fetch the product data from.
 * @param {jQuery} $productCard - The jQuery object representing the product card DOM element to update.
 */
function productUpdate(urlParam, $productCard) {
    const url = getSelectionUrl(urlParam);
    if (url) {
        $productCard.spinner().start();
        $.ajax({
            url: url,
            method: 'GET',
            success: function (response) {
                const product = response && response.product ? response.product : null;
                if (product) {
                    $productCard.find('.custom-product-name').empty().text(product.productName);
                    $productCard.find('.prices').empty().html(product.price.html);
                    const productImage = product.images.small[0];
                    $productCard.find('.custom-product-image img').attr('src', productImage.src).attr('title', productImage.title).attr('alt', productImage.alt);
                    updateAttrs(product.variationAttributes, $productCard);
                    if ($productCard.closest('.boutique-overlay').length) {
                        const $countryEle = $('.boutique-country select');
                        const country = $countryEle.val();
                        if (product.readyToOrder && country) {
                            $(document).trigger('boutiqueUpdateStores', {
                                url: $countryEle.data('action'),
                                pid: product.id,
                                country: country,
                            });
                        }
                    }
                    $('.custom-product-card', $productCard).data('pid', product.id);
                }
                $productCard.spinner().stop();
            },
            error: function () {
                $productCard.spinner().stop();
            },
        });
    }
}

const initCustomVariation = function () {
    const $document = $(document);
    $document.on('change', '.custom-variation-select', function (e) {
        e.preventDefault();
        const $this = $(this);
        if (selectUiUpdate) {
            return;
        }
        const $productCard = $this.closest('.custom-slider-body');
        const thisValue = e.currentTarget.value;
        $this.siblings().find('.invalid-feedback').toggleClass('d-block', !thisValue);
        if (thisValue) {
            $this.siblings('.invalid-feedback').removeClass('d-none');
            productUpdate(thisValue, $productCard);
            $('.notify-attr-checkbox-wrapper .notify-attr-value').text(thisValue);
        }
    });
    $document.on('customVariationUpdate', function (e, data) {
        productUpdate(data.url, data.wrapperEle);
    });
};

module.exports = {
    initCustomVariation: initCustomVariation,
};
